import * as React from "react";
import { useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { BootstrapModalForm } from "components/bootstrap";
import { TimeUnitInput } from "components/common";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { setWatchlistDefaultTtl } from "watchlist/hooks/useWatchlistsV2";
const TTL_UNITS = ["DAYS", "HOURS", "MINUTES", "SECONDS"];
const DEFAULT_TTL_SECONDS = 24 * 60 * 60;
const SetDefaultTtlModal = ({ watchlistId, watchlistName, currentTtlSeconds = 0, onClose, onUpdated }) => {
  const hasTtl = currentTtlSeconds > 0;
  const initial = extractDurationAndUnit((hasTtl ? currentTtlSeconds : DEFAULT_TTL_SECONDS) * 1e3, TTL_UNITS);
  const [enabled, setEnabled] = useState(hasTtl);
  const [duration, setDuration] = useState(initial.duration);
  const [unit, setUnit] = useState(initial.unit);
  const [submitting, setSubmitting] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { t } = useTranslation("enterprise_search");
  const handleChange = (nextValue, nextUnit, checked) => {
    setEnabled(checked);
    setDuration(nextValue);
    setUnit(nextUnit);
  };
  const handleSubmit = () => {
    const seconds = enabled ? Math.round(moment.duration(Math.max(duration, 1), unit).asSeconds()) : 0;
    if (!Number.isFinite(seconds) || seconds < 0) {
      UserNotification.error(t("set_default_ttl_modal.ttl_negative"));
      return;
    }
    setSubmitting(true);
    setWatchlistDefaultTtl(watchlistId, seconds).then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.WATCHLIST.DEFAULT_TTL_SET, {
        app_section: "watchlist-details",
        app_action_value: "watchlist-default-ttl-set",
        event_details: { watchlist_name: watchlistName, ttl_seconds: seconds }
      });
      UserNotification.success(
        seconds > 0 ? t("set_default_ttl_modal.ttl_set", { count: seconds, watchlistName }) : t("set_default_ttl_modal.ttl_cleared", { watchlistName })
      );
      onUpdated();
      onClose();
    }).catch((error) => UserNotification.error(t("set_default_ttl_modal.setting_failed", { error: `${error}` }))).finally(() => setSubmitting(false));
  };
  return /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: true,
      title: t("set_default_ttl_modal.title", { watchlistName }),
      onSubmitForm: handleSubmit,
      onCancel: onClose,
      submitButtonText: submitting ? t("set_default_ttl_modal.saving") : t("set_default_ttl_modal.save"),
      submitButtonDisabled: submitting
    },
    /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: t("set_default_ttl_modal.label"),
        help: t("set_default_ttl_modal.help"),
        update: handleChange,
        value: duration,
        unit,
        units: TTL_UNITS,
        enabled
      }
    )
  );
};
export default SetDefaultTtlModal;
